import { ManageGroupsParams } from './useQueryGetGroupsWithFilters';
import { ISingleGroupParams } from './useQueryGetSingleGroup';

export const landingPageDesignGroupsKeys = {
  all: () => ['LANDING_PAGE_DESIGN_GROUPS'],
  list: (params: ManageGroupsParams) => ['LANDING_PAGE_DESIGN_GROUPS', params],
  single_group_landing_pages: (params: ISingleGroupParams) => [
    'LANDING_PAGE_DESIGN_GROUP',
    params,
  ],
};
